import { api } from './client'

export interface MyZtnaApp {
  id: number
  slug: string
  display_name: string
  hostname: string
  tenant_id: number
  environment: string
  enabled: boolean
}

export interface MyZtnaAppsResponse {
  items: MyZtnaApp[]
  total: number
}

export const meApi = {
  listZtnaApps: async (): Promise<MyZtnaAppsResponse> => {
    const res = await api.get<MyZtnaAppsResponse>('/v1/me/ztna-apps')
    return res.data
  },
}
